import React, { Component } from 'react';
import Hero from '../modules/Hero/Hero';
import globals from '../globals';
import ContactBlock from '../modules/ContactBlock';
import Button from '../elements/Button';
import HelmetDefault from "../layout/HelmetDefault";

class Contact extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            seoTitle: '',
            seoDescription: '',
            general: {},
            support: {},
            provisioning: {},
            billing: {},
            smb_support: {},
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/contact')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                globals.animatePageIn(this.container);
            });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={false}>
                    <div className="contact-blocks">
                        <ContactBlock
                            phone={this.state.general.phone}
                            title={this.state.general.title}
                            subTitle={this.state.general.subTitle}
                            hours={this.state.general.hours}
                            contactEmail={this.state.general.contactEmail}
                            extra=""
                        />
                        <ContactBlock
                            phone={this.state.support.phone}
                            title={this.state.support.title}
                            subTitle={this.state.support.subTitle}
                            hours={this.state.support.hours}
                            contactEmail={this.state.support.contactEmail}
                            extra=""
                        />
						<ContactBlock
							phone={this.state.provisioning.phone}
							title={this.state.provisioning.title}
							subTitle={this.state.provisioning.subTitle}
							hours={this.state.provisioning.hours}
                            contactEmail={this.state.provisioning.contactEmail}
                            extra=""
						/>
						<ContactBlock
							phone={this.state.billing.phone}
							title={this.state.billing.title}
							subTitle={this.state.billing.subTitle}
							hours={this.state.billing.hours}
                            contactEmail={this.state.billing.contactEmail}
                            extra=""
						/>
                        <ContactBlock
							phone={this.state.smb_support.phone}
							title={this.state.smb_support.title}
							subTitle={this.state.smb_support.subTitle}
							hours={this.state.smb_support.hours}
                            contactEmail={this.state.smb_support.contactEmail}
                            extra={this.state.smb_support.extra}
						/>

                        <Button
                            action={(event) => window.slideFormContainer ? window.slideFormContainer.animateIn(event) : null}
                            image="/images/btn-get-in-touch.svg"
                            alt="Get in touch"
                        />
                    </div>
                </Hero>
            </div>
        );
    }

}

export default Contact;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Contact.js